// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1RmiF","assignButton":"CreateEditEquipmentSchedule_assignButton__2cLHf"};